import { computed } from 'mobx';

import createContext from 'bz-utilities/hooks/context-v2';
import CacheStore from 'bz-utilities/modules/stores/cached-map-store';

import type { LocationResponse } from 'tm3-core/api.dtos';
import ELocationStatus from 'tm3-core/interfaces/location/enums/status';

export const [LocationsStoreCtx, useLocationsStore] =
  createContext<LocationsStore>('LocationsStore');

class LocationsStore extends CacheStore<LocationResponse> {
  constructor() {
    super('locations');
  }

  public search(searchTerm: string = ''): LocationResponse[] {
    const lowerSearchTerm = searchTerm.toLowerCase();
    return this.CurrentLocations.filter(
      (location) =>
        location?.name?.toLowerCase().includes(lowerSearchTerm) ||
        location?.addressLine1?.toLowerCase().includes(lowerSearchTerm) ||
        location?.addressline2?.toLowerCase().includes(lowerSearchTerm) ||
        location?.addressline5?.toLowerCase().includes(lowerSearchTerm)
    );
  }

  @computed
  get CurrentLocations(): LocationResponse[] {
    const live = ELocationStatus.Live.toString();
    return this.All.filter((x) => x.status === live); // not sure why this is a string
  }
}

export default LocationsStore;
